<div style="z-index: 10000;">
  <div    class="square-div" [class.my_square_div] = "name != '-'"  [style.background]="bg_color ? bg_color : '#DAE4F2'"  [class.has-children]="!!children?.length">
    @if (name != '-') {
      <div  style="display: flex;background: white;padding: 2px 4px;">
        <img [src]="owner_profile_image_path">
        <div>
          <p class="title">
            {{name | truncateStrPipe : 12}}
          </p>
          <p class="sub-title">
            {{
            owner_type
            }}
          </p>
          <p class="sub-value">
            ${{
            position_value | roundAmountTwoDecimal
            }}
          </p>
        </div>
      </div>
    }
    @if (name != '-') {
      <div  class="footer" >
        <p class="group-title" > {{children.length}}  {{ children.length == 1 ?  'Group': 'Groups'}}</p>
        <div style="height: 8px;">
          <span class="material-symbols-outlined material-icons small-menu-icon"> add </span>
          <span class="material-symbols-outlined material-icons small-menu-icon"> sort </span>
        </div>
      </div>
    }

  </div>
  @if (children) {
    <div
      class="children"
      >
      @for (node of children; track node) {
        <node
          [name]="node.name"
          [bg_color]="node.bg_color"
          [children]="node.children"
          >
        </node>
      }
    </div>
  }
</div>